import { ComponentProps } from "react";
import { ToggleIcon } from "./ToggleIcon";
import { css, useTheme } from "@emotion/react";

export function Download({
  variant = "filled",
  checked = false,
  ...props
}: {
  variant?: "filled" | "icon";
} & Omit<ComponentProps<typeof ToggleIcon>, "iconSpec">) {
  const theme = useTheme();

  const { unchecked, checked: checkedSpec } = (
    {
      filled: {
        unchecked: {
          enabled: {
            color: "white",
            backgroundColor: "white",
            borderRadius: 8,
          },
          hover: {
            color: "white",
            backgroundColor: "white",
          },
        },
        checked: {
          enabled: {
            color: theme.palette.subcolor.orange,
            backgroundColor: "white",
            borderRadius: 8,
          },
          hover: {
            color: theme.palette.subcolor.orange,
            backgroundColor: "white",
          },
        },
      },
      icon: {
        unchecked: {
          enabled: {
            color: "white",
            backgroundColor: "transparent",
            borderRadius: 8,
          },
          hover: {
            color: "black",
            backgroundColor: "transparent",
          },
        },
        checked: {
          enabled: {
            color: theme.palette.subcolor.orange,
            backgroundColor: "transparent",
            borderRadius: 8,
          },
          hover: {
            color: theme.palette.subcolor.orange,
            backgroundColor: "transparent",
          },
        },
      },
    } as const
  )[variant];

  return (
    <ToggleIcon
      css={css`
      &:hover {
        svg path {
          fill: none;
          stroke: rgba(158, 158, 158, 1);
        }
      }
    `}
      iconSpec={{
        unchecked: {
          name: "DownloadOutlined",
          ...unchecked,
        },
        checked: {
          name: "DownloadFilled",
          ...checkedSpec,
        },
      }}
      checked={checked}
      size="medium"
      {...props}
    />
  );
}
